<template>
    <v-app id="login">
        <router-view/>
        <v-row no-gutters>
            <v-col lg="3">
                <div id="leftSide" :style="`background-image: url(${securityStore.getImageLink()}/reset-password.jpg)`"></div>
            </v-col>
            <v-col lg="3" md="2"></v-col>
            <v-col lg="3" md="5">
                <div id="rightSide">
                    <v-card color="basil">
                        <v-card-title class="text-center justify-center py-6">
                            <h1 class="font-weight-bold display-3 basil--text">
                                {{ $t("app_name") }}
                            </h1>
                        </v-card-title>

                        <v-card color="basil" flat>
                            <v-card-text>
                                <v-container fluid>
                                    <v-row justify="center" align="center">
                                        <h1>
                                            <strong>Modifier Mot de Passe</strong>
                                        </h1>
                                    </v-row>
                                    <br/>
                                    <br/>
                                    <v-row justify="center">
                                        <v-col cols="12">
                                            <v-text-field
                                                v-model="password"
                                                label="Mot de passe"
                                                type="password"
                                                append-icon="mdi-email-outline"
                                                outlined
                                                :color="inputColor"
                                                :background-color="backgroundColor"
                                            ></v-text-field>
                                        </v-col>
                                        <v-col cols="12">
                                            <v-text-field
                                                v-model="confirmPassword"
                                                label="Confirmer mot de passe"
                                                append-icon="mdi-key"
                                                outlined
                                                type="password"
                                                @keyup.enter="reset"
                                                :color="inputColor"
                                                :background-color="backgroundColor"
                                            ></v-text-field>
                                        </v-col>
                                    </v-row>
                                    <v-row justify="center">
                                        <v-col md="10"></v-col>
                                    </v-row>
                                </v-container>
                            </v-card-text>
                            <v-divider/>
                            <v-card-actions>
                                <v-spacer/>
                                <v-btn
                                    color="teal"
                                    outlined
                                    depressed
                                    dark
                                    @click="getBack"
                                >
                                    {{ $t("common.cancel") }}
                                    <v-icon right>mdi-close</v-icon>
                                </v-btn>
                                <v-btn
                                    color="orange"
                                    depressed
                                    dark
                                    @click="reset"
                                    :loading="loading"
                                >
                                    {{ $t("common.edit") }}
                                    <v-icon right>mdi-pencil</v-icon>
                                </v-btn>
                            </v-card-actions>
                        </v-card>
                    </v-card>
                </div>
            </v-col>
            <v-col lg="3" md="2"></v-col>
        </v-row>
    </v-app>
</template>

<script>
import {useSecurityStore} from "@/stores/Security";
import axios from "axios";
import {ref} from "vue";
import useSharedMethod from "@/use/SharedMethod";
import useSharedData from "@/use/SharedData";

export default {
    setup() {
        const securityStore = useSecurityStore();
        const {logout, getBack} = useSharedMethod();
        const {loading, inputColor, backgroundColor} = useSharedData();
        const password = ref(null);
        const confirmPassword = ref(null);

        function reset() {
            loading.value = true;
            axios.put(`/users/resetPassword/${password.value}`).then(() => {
                logout();
            }).finally(() => {
                loading.value = false;
            });
        }

        return {
            securityStore,
            loading,
            inputColor,
            backgroundColor,
            password,
            confirmPassword,
            reset,
            getBack
        }
    }
};
</script>

<style scoped>
#login {
    background-color: #f2f5f8;
}

#leftSide {
    min-height: 100vh;
    background-position: center;
    background-repeat: no-repeat;
    background-size: cover;
}

#rightSide {
    min-height: 60%;
    background-position: center;
    margin-top: 40%;
}
</style>
